// Zentrale Anzeige-Schwelle (in Pa) für den Druckverlust-Warnhinweis
// (Issue #23). Überschreitet der angezeigte Druckverlust diesen Wert, wird
// hinter dem Druckverlustwert ein Warnhinweis eingeblendet.
//
// Wichtig: Dies ist eine reine Darstellungs-Konstante. Sie ist KEIN Teil der
// Druckverlustberechnung und verändert keine Berechnungslogik.
export const PRESSURE_DROP_WARNING_THRESHOLD = 90;
